import React from "react";
import PropTypes from "prop-types";

function CompanyName(props) {
  const { company } = props;

  const NameTag = ({company}) => {
    return (<h5 className='text-center'>{company.name}</h5>);
  };

  return (
    <a href={`companies/${company.url_path_name}`} className='invest-name' data-turbolinks='false'>
      <NameTag {...props} />
    </a>
  );
}

CompanyName.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url_path_name: PropTypes.string.isRequired
  }).isRequired,
};

export default CompanyName;
